function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import 'ka-table/style.css';
import React, { Fragment, useEffect, useState } from 'react';
import { kaReducer, Table } from 'ka-table';
import { DataType, EditingMode, SortingMode } from 'ka-table/enums';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faTrash } from "@fortawesome/free-solid-svg-icons";
import CustomEditor from "./CustomEditor";
import { Button } from "../../components";
import AddColumnModal from "./AddColumnModal";
import { insertColumn } from "ka-table/actionCreators";
import orderBy from "lodash/orderBy";
import { useSnackbar } from "notistack";
import EditColumnFields from "./EditColumnFields";
import { isPresent, pluralize } from "../../utils";
import { toRubricsFormat } from "./utils";
var columnsByOrder = function columnsByOrder(columns) {
  return orderBy(columns, ['order'], ['asc']);
};
var transformData = function transformData(baseData) {
  return (baseData === null || baseData === void 0 ? void 0 : baseData.map(function (item) {
    var result = {};
    result['Learning Outcome'] = item['Learning Outcome'];
    columnsByOrder(item.columns).forEach(function (column) {
      result[column['name']] = column['value'];
    });
    return result;
  })) || [];
};
var EditableTable = function EditableTable(_ref) {
  var _;
  var defaultData = _ref.defaultData,
    columnReordering = _ref.columnReordering,
    learningObjectives = _ref.learningObjectives,
    onUpdated = _ref.onUpdated;
  var ACTION_UPDATE_DATA = 'ACTION_UPDATE_DATA';
  var ACTION_DELETE_COLUMNS = 'ACTION_DELETE_COLUMNS';
  var ACTION_EDIT_COLUMN = 'ACTION_EDIT_COLUMN';

  // filter out any possible deleted column
  var filteredData = defaultData.map(function (item) {
    var filteredColumns = item.columns.filter(function (column) {
      return !column.hasOwnProperty('_destroy');
    });
    return _objectSpread(_objectSpread({}, item), {}, {
      columns: filteredColumns
    });
  });
  var transformedData = transformData(filteredData);
  var columns = ((_ = _toConsumableArray(filteredData)[0]) === null || _ === void 0 ? void 0 : _.columns.map(function (item, index) {
    return {
      key: item.name,
      title: item.name,
      type: DataType.String,
      width: 200,
      isEditable: true,
      point: item.point || index
    };
  })) || [];
  columns.unshift({
    key: 'Learning Outcome',
    title: 'Learning Outcome',
    type: DataType.String,
    width: 200,
    isEditable: false
  });
  var data = transformedData.map(function (item, index) {
    return _objectSpread(_objectSpread({}, item), {}, {
      id: index
    });
  });
  var sortingMode = SortingMode.None;
  var editingMode = EditingMode.None;
  var rowKeyField = 'id';
  var childComponents = {
    table: {
      elementAttributes: function elementAttributes() {
        return {
          className: 'table table-striped table-hover table-bordered'
        };
      }
    },
    tableHead: {
      elementAttributes: function elementAttributes() {
        return {
          className: 'cursor-move'
        };
      }
    },
    tableBody: {
      elementAttributes: function elementAttributes() {
        return {
          className: 'cursor-pointer'
        };
      }
    },
    cellEditor: {
      content: function content(props) {
        return /*#__PURE__*/React.createElement(CustomEditor, Object.assign({
          dispatch: dispatch
        }, props));
      }
    },
    cellText: {
      content: function content(props) {
        if (props.field === 'Learning Outcome') {
          return props.value;
        } else {
          return /*#__PURE__*/React.createElement(CustomEditor, Object.assign({
            dispatch: dispatch
          }, props));
        }
      }
    }
  };
  if (columnReordering) {
    childComponents['headCellContent'] = {
      content: function content(props) {
        return /*#__PURE__*/React.createElement("div", {
          className: "d-flex justify-content-between"
        }, /*#__PURE__*/React.createElement("div", null, props.column.title === 'Learning Outcome' ? /*#__PURE__*/React.createElement("span", null, props.column.title) : /*#__PURE__*/React.createElement(EditColumnFields, {
          column: props.column,
          onEdit: handleEditColumn
        })), props.column.title !== 'Learning Outcome' && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
          onClick: function onClick() {
            return deleteColumn(props.column);
          },
          icon: faTrash,
          className: "text-danger cursor-pointer"
        })));
      }
    };
  }
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showAddColumnModal = _useState2[0],
    setShowAddColumnModal = _useState2[1];
  var _useState3 = useState({
      columns: columns,
      data: data,
      childComponents: childComponents,
      columnReordering: columnReordering,
      sortingMode: sortingMode,
      rowKeyField: rowKeyField,
      editingMode: editingMode
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    tableProps = _useState4[0],
    changeTableProps = _useState4[1];
  var _useState5 = useState(_toConsumableArray(defaultData)),
    _useState6 = _slicedToArray(_useState5, 2),
    baseData = _useState6[0],
    setBaseData = _useState6[1];
  var _useSnackbar = useSnackbar(),
    enqueueSnackbar = _useSnackbar.enqueueSnackbar;
  var handleAddColumn = function handleAddColumn(column) {
    dispatch(insertColumn({
      key: column.title,
      title: column.title,
      type: DataType.String,
      width: 200,
      isEditable: true,
      point: column.point || 3
    }, tableProps.columns.length));
    var newData = tableProps.data.map(function (item) {
      item[column.title] = '';
      return item;
    });
    dispatch({
      type: ACTION_UPDATE_DATA,
      data: newData
    });
    setShowAddColumnModal(false);
  };
  var handleEditColumn = function handleEditColumn(column) {
    dispatch({
      type: ACTION_EDIT_COLUMN,
      column: column
    });
  };
  var deleteColumn = function deleteColumn(column) {
    if (window.confirm('Deleting this column will clear all the data in it, are you sure you want to continue?')) {
      dispatch({
        type: ACTION_DELETE_COLUMNS,
        title: column.title
      });
    }
  };
  var dispatch = function dispatch(action) {
    // dispatch has an *action as an argument
    switch (action.type) {
      case ACTION_UPDATE_DATA:
        changeTableProps(function (prevState) {
          return _objectSpread(_objectSpread({}, prevState), {}, {
            data: action.data
          });
        });
        break;
      case ACTION_DELETE_COLUMNS:
        changeTableProps(function (prevState) {
          var updatedColumns = prevState.columns.filter(function (item) {
            return item.title !== action.title;
          });
          var updatedData = prevState.data.map(function (item) {
            delete item[action.title];
            return item;
          });
          return _objectSpread(_objectSpread({}, prevState), {}, {
            columns: updatedColumns,
            data: updatedData
          });
        });
        setBaseData(function (prev) {
          var updatedData = prev.map(function (item) {
            var columns = item.columns;
            var index = columns.findIndex(function (column) {
              return column.name === action.title;
            }); // index of column to delete
            if (index === -1) return item;
            var column = columns[index];
            if (column.id) {
              columns[index] = _objectSpread(_objectSpread({}, column), {}, {
                _destroy: true
              });
            } else {
              columns.splice(index, 1);
            }

            // Reset order after deleting
            var unDeletedColumns = columns.filter(function (column) {
              return !column.hasOwnProperty('_destroy');
            }).map(function (column, index) {
              return _objectSpread(_objectSpread({}, column), {}, {
                order: index
              });
            });
            var deletedColumns = columns.filter(function (column) {
              return column.hasOwnProperty('_destroy');
            });
            return _objectSpread(_objectSpread({}, item), {}, {
              columns: columnsByOrder(deletedColumns.concat(unDeletedColumns))
            });
          });
          console.log('updatedData', updatedData);
          onUpdated(updatedData);
          return updatedData;
        });
        break;
      case ACTION_EDIT_COLUMN:
        changeTableProps(function (prevState) {
          var updatedColumns = prevState.columns.map(function (item) {
            if (item.title === action.column.title) {
              item['key'] = action.column.newTitle;
              item['title'] = action.column.newTitle;
              item['point'] = action.column.newPoint;
            }
            return item;
          });
          var updatedData = prevState.data.map(function (item) {
            if (action.column.newTitle !== action.column.title) {
              item[action.column.newTitle] = item[action.column.title];
              delete item[action.column.title];
            }
            return item;
          });
          return _objectSpread(_objectSpread({}, prevState), {}, {
            columns: updatedColumns,
            data: updatedData
          });
        });
        setBaseData(function (prev) {
          var updatedData = prev.map(function (item) {
            var columns = item.columns;
            var index = columns.findIndex(function (column) {
              return column.name === action.column.title;
            }); // index of column to delete
            if (index === -1) return item;
            var column = columns[index];
            columns[index] = _objectSpread(_objectSpread({}, column), {}, {
              name: action.column.newTitle,
              point: action.column.newPoint
            });
            return _objectSpread(_objectSpread({}, item), {}, {
              columns: columns
            });
          });
          onUpdated(updatedData);
          return updatedData;
        });
        break;
      default:
        if (action.type === 'ReorderColumns') {
          if (action.columnKey === 'Learning Outcome' || action.targetColumnKey === 'Learning Outcome') {
            enqueueSnackbar('You cannot move the Learning Outcome column', {
              variant: 'error'
            });
            return;
          } else {
            setBaseData(function (prev) {
              var result = _toConsumableArray(prev);
              result = result.map(function (item) {
                var sourceColumnOrder = item.columns.find(function (column) {
                  return column.name === action.columnKey;
                }).order;
                var targetColumnOrder = item.columns.find(function (column) {
                  return column.name === action.targetColumnKey;
                }).order;
                var updatedColumns = item.columns.map(function (column) {
                  if (column.name === action.columnKey) {
                    column.order = targetColumnOrder;
                  } else if (column.name === action.targetColumnKey) {
                    column.order = sourceColumnOrder;
                  }
                  return column;
                });
                return _objectSpread(_objectSpread({}, item), {}, {
                  columns: columnsByOrder(updatedColumns)
                });
              });
              onUpdated(result);
              return result;
            });
          }
        }
        changeTableProps(function (prevState) {
          return kaReducer(prevState, action);
        });
        if (action.type === 'InsertColumn') {
          setBaseData(function (prev) {
            var updatedBaseData = prev === null || prev === void 0 ? void 0 : prev.map(function (item) {
              return _objectSpread(_objectSpread({}, item), {}, {
                columns: [].concat(_toConsumableArray(item.columns), [{
                  name: action.column.title,
                  value: '',
                  order: item.columns.length,
                  point: action.column.point
                }])
              });
            });
            onUpdated(updatedBaseData);
            return updatedBaseData;
          });
        }
        if (action.type === 'UpdateCellValue') {
          var updatedData = _toConsumableArray(tableProps.data);
          updatedData[action.rowKeyValue][action.columnKey] = action.value;
          setBaseData(function (prev) {
            var result = _toConsumableArray(prev);
            result[action.rowKeyValue]['columns'] = result[action.rowKeyValue]['columns'].map(function (column) {
              if (column.name === action.columnKey) return _objectSpread(_objectSpread({}, column), {}, {
                value: action.value
              });else return column;
            });
            onUpdated(result);
            return result;
          });
        }
    }
  };
  useEffect(function () {
    if (isPresent(defaultData)) {
      changeTableProps(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          columns: columns,
          data: data
        });
      });
      setBaseData(function () {
        return defaultData;
      });
    } else {
      changeTableProps(function (prev) {
        var columns = ['Fail', 'Pass', 'Merit'].map(function (item, index) {
          return {
            key: item,
            title: item,
            type: DataType.String,
            width: 200,
            isEditable: true,
            point: index + 1
          };
        });
        columns.unshift({
          key: 'Learning Outcome',
          title: 'Learning Outcome',
          type: DataType.String,
          width: 200,
          isEditable: false
        });
        var data = learningObjectives.map(function (item, index) {
          return {
            "Learning Outcome": item.name,
            Fail: '',
            Pass: '',
            Merit: '',
            id: index
          };
        });
        return _objectSpread(_objectSpread({}, prev), {}, {
          columns: columns,
          data: data
        });
      });
      setBaseData(function () {
        var data = learningObjectives.map(function (item, index) {
          return {
            "Learning Outcome": item.name,
            Fail: '',
            Pass: '',
            Merit: ''
          };
        });
        return toRubricsFormat(data);
      });
    }
  }, [defaultData]);
  useEffect(function () {
    if (isPresent(defaultData)) {
      // deleting a learning objective
      if (learningObjectives.length < tableProps.data.length) {
        if (learningObjectives.length === 1 && learningObjectives[0].name === '' && !learningObjectives[0].slug) return;
        var index = tableProps.data.findIndex(function (item) {
          // index of deleted item
          return !learningObjectives.find(function (objective) {
            return objective.name === item['Learning Outcome'];
          });
        });
        changeTableProps(function (prev) {
          var newData = _toConsumableArray(prev.data);
          newData.splice(index, 1);
          newData = newData.map(function (data, index) {
            return _objectSpread(_objectSpread({}, data), {}, {
              id: index
            });
          });
          return _objectSpread(_objectSpread({}, prev), {}, {
            data: newData
          });
        });
        setBaseData(function (prev) {
          var newData = _toConsumableArray(prev);
          newData.splice(index, 1);
          newData = newData.map(function (data, index) {
            return _objectSpread(_objectSpread({}, data), {}, {
              index: index
            });
          });
          onUpdated(newData);
          return newData;
        });
      }

      // adding a learning objective
      if (learningObjectives.length > tableProps.data.length) {
        var addedObjective = learningObjectives[learningObjectives.length - 1];
        changeTableProps(function (prev) {
          var newRow = {
            'Learning Outcome': addedObjective.name,
            id: learningObjectives.length
          };
          prev.columns.forEach(function (column) {
            return newRow[column.title] = '';
          });
          var newData = _toConsumableArray(prev.data);
          newData.push(newRow);
          return _objectSpread(_objectSpread({}, prev), {}, {
            data: newData
          });
        });
        setBaseData(function (prev) {
          var newRow = {
            'Learning Outcome': addedObjective.name,
            index: learningObjectives.length
          };
          newRow['columns'] = prev[0].columns.map(function (column) {
            return _objectSpread(_objectSpread({}, column), {}, {
              value: ''
            });
          });
          var newData = _toConsumableArray(prev);
          newData.push(newRow);
          onUpdated(newData);
          return newData;
        });
      }

      // updating a learning objective or swapping learning objectives
      if (learningObjectives.length === tableProps.data.length) {
        // data that changed or are swapped
        var changedData = tableProps.data.filter(function (item, lIndex) {
          return item['Learning Outcome'] !== learningObjectives[lIndex].name;
        });

        // Updating a learning objective
        if (changedData.length <= 1) {
          var _index = tableProps.data.findIndex(function (item, lIndex) {
            return item['Learning Outcome'] !== learningObjectives[lIndex].name;
          });
          if (_index === -1) return;
          changeTableProps(function (prev) {
            var newData = prev.data.map(function (item, dIndex) {
              return dIndex === _index ? _objectSpread(_objectSpread({}, item), {}, {
                'Learning Outcome': learningObjectives[_index].name
              }) : item;
            });
            return _objectSpread(_objectSpread({}, prev), {}, {
              data: newData
            });
          });
          setBaseData(function (prev) {
            var newData = prev.map(function (item, dIndex) {
              return dIndex === _index ? _objectSpread(_objectSpread({}, item), {}, {
                'Learning Outcome': learningObjectives[_index].name
              }) : item;
            });
            onUpdated(newData);
            return newData;
          });
        } else {
          // Swapping learning objectives
          changeTableProps(function (prev) {
            var newData = _toConsumableArray(prev.data);
            changedData.forEach(function (data) {
              // index of changed data in the gloabal learning objectives
              var index = learningObjectives.findIndex(function (item, lIndex) {
                return data['Learning Outcome'] === item.name;
              });
              newData[index] = data;
            });
            return _objectSpread(_objectSpread({}, prev), {}, {
              data: newData
            });
          });
          setBaseData(function (prev) {
            var newData = _toConsumableArray(prev);
            var changedData = newData.filter(function (item, lIndex) {
              return item['Learning Outcome'] !== learningObjectives[lIndex].name;
            });
            changedData.forEach(function (data) {
              // index of changed data in the gloabal learning objectives
              var index = learningObjectives.findIndex(function (item, lIndex) {
                return data['Learning Outcome'] === item.name;
              });
              newData[index] = data;
            });
            onUpdated(newData);
            return newData;
          });
        }
      }
    }
  }, [learningObjectives].concat(_toConsumableArray(learningObjectives.map(function (item) {
    return item.name;
  }))));
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "text-end p-3"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "btn-sm",
    color: "nurture-green",
    onClick: function onClick() {
      return setShowAddColumnModal(true);
    }
  }, "Add Column")), /*#__PURE__*/React.createElement(Table, Object.assign({}, tableProps, {
    dispatch: dispatch
  })), /*#__PURE__*/React.createElement(AddColumnModal, {
    show: showAddColumnModal,
    onAdd: handleAddColumn,
    toggle: function toggle() {
      return setShowAddColumnModal(!showAddColumnModal);
    }
  }));
};
EditableTable.defaultProps = {
  columnReordering: true,
  defaultData: []
};
export default EditableTable;